/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************************************!*\
  !*** ./resources/js/modules/sections/collection-on-scroll.js ***!
  \***************************************************************/
// mouse drag scroll
var coll_wrapper = document.querySelector('.coll-slider-wrapper');
var coll_container = document.querySelector('.coll-slider-wrapper');

if (coll_wrapper) {
  coll_wrapper.scrollLeft = -200;
  var isDown = false;
  var startX;
  var scrollLeft;
  coll_wrapper.addEventListener('mousedown', function (e) {
    isDown = true;
    coll_wrapper.classList.add('active');
    startX = e.pageX - coll_wrapper.offsetLeft;
    scrollLeft = coll_wrapper.scrollLeft;
  });
  coll_wrapper.addEventListener('mouseleave', function () {
    isDown = false;
    coll_wrapper.classList.remove('active');
  });
  coll_wrapper.addEventListener('mouseup', function () {
    isDown = false;
    coll_wrapper.classList.remove('active');
  });
  coll_wrapper.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - coll_wrapper.offsetLeft;
    var walk = (x - startX) * 2; //scroll-fast

    coll_wrapper.scrollLeft = scrollLeft - walk;
  }); // scroll horizontal on page scroll when in window

  var coll_observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting == true) {
        // add event listener for window scroll events
        var oldValue = 0;
        var newValue = 0;
        window.addEventListener('scroll', function () {
          // get element Y position in viewport
          var viewportOffset = coll_wrapper.getBoundingClientRect();
          var top = viewportOffset.top / 10; // get scroll X position of wrapper

          var coll_wrapper_x = coll_wrapper.scrollLeft;
          newValue = top;

          if (window.innerWidth < 768) {
            if (oldValue < newValue) {
              coll_container.scrollLeft = coll_wrapper_x - 8;
            } else if (oldValue > newValue) {
              coll_container.scrollLeft = coll_wrapper_x + 8;
            }

            oldValue = newValue;
          } else {
            if (oldValue < newValue) {
              coll_wrapper.scrollLeft = coll_wrapper_x - 2;
            } else if (oldValue > newValue) {
              coll_wrapper.scrollLeft = coll_wrapper_x + 2;
            }

            oldValue = newValue;
          } // set scroll x of collection wrapper
          // coll_container.scrollLeft = coll_wrapper_x + top;

        });
      }
    });
  });
  coll_observer.observe(coll_container);
} // window.addEventListener('scroll', () => {
//     const coll_container = document.querySelector('.coll-slider-container');
//     const window_scroll = window.scrollY;
//     window.log(window_scroll);
// });
/******/ })()
;